$.context = (key, fallback) => $.get('context' + (key ? '.' + key : ''), fallback);